import React from 'react';
import './UserMenu.scss';
import Dropdown from 'react-bootstrap/Dropdown';
import { Link } from 'react-router-dom';
import { Icon } from '../../features/icon/Icon';
import { ERouterPath } from '../../features/router/ERouterPath';
import { Avatar } from '../../features/avatar/Avatar';
import { ISessionAppState } from '../../app/session/reducer';
import { ApplicationState } from '../../app/store';
import { useSelector } from 'react-redux';
import { UserAccountRoleEnum } from '../../api/types';

type UserMenuProps = {
  session?: ISessionAppState,
}

type ButtonProps = React.HTMLProps<HTMLButtonElement> & UserMenuProps;

const CustomUserMenuToggle = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ session, onClick }, ref) => {
    session = session as ISessionAppState;
    return (
      <button
        className="user-menu"
        ref={ref}
        onClick={(e) => {
          e.preventDefault();
          if (onClick) {
            onClick(e);
          }
        }}
      >

        <div className="user-menu__container">
          <Avatar className="user-menu__avatar" user={session?.user} />
          <div className="user-menu__welcome">Welkom,</div>
          <div className="user-menu__name">
            {session?.user?.name || ''}</div>
        </div>
        <Icon icon="dropdown" className="user-menu__icon"/>
      </button>
    );
  }
);


export function UserMenu(): JSX.Element {
  const session = useSelector<ApplicationState, ISessionAppState>(state => state.session);
  const displayFileSwitcher = (
    session.isMultiDossierUser &&
    session.user &&
    [UserAccountRoleEnum.caregiver, UserAccountRoleEnum.administration, UserAccountRoleEnum.adminCaregiver].includes(session.user.accountRole) === false
  );

  return (
    <Dropdown className="user-menu-dropdown">
      <Dropdown.Toggle as={CustomUserMenuToggle} id="user-menu-dropdown" session={session} />

      <Dropdown.Menu alignRight>
        <Link to={ERouterPath.accountSettings}>
          <Dropdown.Item as="div">Mijn gegevens</Dropdown.Item>
        </Link>
        <Dropdown.Divider />
        {
          displayFileSwitcher &&
          <>
            <Link to={ERouterPath.selectFile}>
              <Dropdown.Item as="div">Van dossier wisselen</Dropdown.Item>
            </Link>
            <Dropdown.Divider />
          </>
        }
        <Link to={ERouterPath.logout}>
          <Dropdown.Item as="div"><Icon icon="logout" className="user-menu-dropdown__icon"/>Uitloggen</Dropdown.Item>
        </Link>
      </Dropdown.Menu>

    </Dropdown>
  );
}
